import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard, LoggedOutGuard } from '@shared/guards';
import { LogoutComponent } from './loggedout/logout/logout.component';
import { PaymentComponent } from './loggedout/payment/payment.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [LoggedInGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then(
      (m) => m.DashboardModule
    )
  },
  {
    path: 'login',
    canActivate: [LoggedOutGuard],
    loadChildren: () => import('./loggedout/signin/signin.module').then(
      (m) => m.SigninModule
    )
  },
  {
    path: 'signup',
    canActivate: [LoggedOutGuard],
    loadChildren: () => import('./loggedout/signup/signup.module').then(
      (m) => m.SignupModule
    )
  },
  {
    path: 'forgot-password',
    canActivate: [LoggedOutGuard],
    loadChildren: () => import('./loggedout/forgot-passwd/forgot-passwd.module').then(
      (m) => m.ForgotPasswdModule
    )
  },
  {
    path: 'logout',
    canActivate: [LoggedInGuard],
    component: LogoutComponent
  },
  {
    path: 'payment',
    component: PaymentComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    // enableTracing: true
  })],
  exports: [RouterModule],
  providers: [LoggedInGuard, LoggedOutGuard]
})
export class AppRoutingModule { }
